var map = {
	"./advance.svg": 32698,
	"./arrow-down.svg": 82244,
	"./arrow-guide.svg": 27632,
	"./arrow-left.svg": 91875,
	"./arrow-up.svg": 24735,
	"./arrow.svg": 95071,
	"./basic.svg": 6670,
	"./close.svg": 68056,
	"./control.svg": 39571,
	"./cross.svg": 62076,
	"./exclamation-triangle.svg": 87748,
	"./home.svg": 9537,
	"./info_outline.svg": 1303,
	"./loading.svg": 26752,
	"./logout.svg": 65334,
	"./package.svg": 9404,
	"./password-eye.svg": 67911,
	"./phone.svg": 77760,
	"./question.svg": 45176,
	"./shopping-cart.svg": 97995,
	"./sorting-arrow.svg": 66300,
	"./tick.svg": 40531,
	"./tick_circle.svg": 5734,
	"./user.svg": 64821,
	"./warning.svg": 97144
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 24078;